// packages/shared-hooks/src/clients/usePatchClient.ts
//
// `PATCH /clients/:id` — minimal diff body (`name` / `comment`). Both list
// and detail caches must refresh: list rows surface the new name, the
// detail drawer shows the updated comment.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClientDetailSchema, type ClientDetail, type PatchClientInput } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function usePatchClient(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientDetail, unknown, PatchClientInput>({
    mutationFn: (input) =>
      client.patch<ClientDetail>(`/clients/${id}`, input, {}, ClientDetailSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(id) });
    },
  });
}
